/**
 * Общая палитра цветов для конструктора мебели (Модуль, Шкаф, Кухня).
 * Соответствует CSS-переменным `--color-furniture-*` в `app/styles/index.css`.
 */

export const FURNITURE_FRONT_COLORS: Record<string, string> = {
	Белый: "#eeece7",
	Шалфей: "#7fa38b",
	Песочный: "#d2bea2",
	Графит: "#4a5056",
	Дуб: "#b58b62",
	Орех: "#7a5640",
};

export const FURNITURE_BODY_COLORS: Record<string, string> = {
	Белый: "#eeece7",
	Дуб: "#b58b62",
	Орех: "#7a5640",
	Графит: "#4a5056",
};

export const FURNITURE_SURFACE_COLORS: Record<string, string> = {
	Мрамор: "#e6e2da",
	Бетон: "#a3a19c",
	"Тёмный камень": "#3a3a39",
	Дуб: "#b58b62",
	Белый: "#eeece7",
	Шалфей: "#7fa38b",
};
